import { Model } from "vue-mc";

export class ProveedorPos extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , permitidos: 0
      , partners: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , permitidos: (permitidos) => permitidos
      , partners: (partners) => partners
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/proveedorPos.js